import React from "react";
import AuditHistory from "./components/AuditHistory";

const AuditPage: React.FC = () => {
  return <AuditHistory />;
};

export default AuditPage;
